import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class UsuarioService {
    url: string = environment.url + 'Usuario.do';

    constructor(private httpClient: HttpClient) {
    }

    cadastrarUsuarioTeste(nomeCompleto, email, usuario, telefone, empresa, pais, comoConheceu) {
        let body = new HttpParams();
        body = body.set('nomeCompleto', nomeCompleto)
            .set('email', email)
            .set('usuario', usuario)
            .set('telefone', encodeURI(telefone))
            .set('empresa', empresa)
            .set('pais', pais)
            .set('comoConheceu', comoConheceu)
            .set('metodo', 'cadastrar');

        return this.httpClient.post(this.url, body);
    }

    recuperarSenha(nomeEmpresa, usuario, email) {
        let body = new HttpParams();
        body = body.set('nomeEmpresa', nomeEmpresa)
            .set('usuario', usuario)
            .set('email', email)
            .set('metodo', 'recuperarSenha');
        
        return this.httpClient.post(this.url, body);
    }
}
